const styles = theme => ({
  button: {
    margin: theme.spacing.unit,
    marginLeft: 0,
    marginTop: 20,
    textAlign: 'center',
    width: '100%',
  },
  deleteButton: {
    color: '#fff',
    position: 'relative',
    right: -10,
  },
  error: {
    color: theme.palette.error.dark,
    fontWeight: 500,
    margin: theme.spacing.unit,
    marginLeft: 0,
  },
  grow: {
    flexGrow: 1,
  },
  menuButton: {
    marginLeft: -12,
    marginRight: 20,
  },
  permissionsSection: {
    marginTop: 10,
  },
  radioGroup: {
    display: 'flex',
    flexDirection: 'row',
  },
  root: {
    backgroundColor: theme.palette.background.paper,
    flexGrow: 1,
    width: '100%',
  },
  textField: {
    margin: theme.spacing.unit,
    marginLeft: 0,
    minWidth: '100%',
  },
});

export default styles;
